import React from "react"
import { View } from "react-native"
import { Spacer } from "@Components/Space"
import styles from "./styles"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { Text } from "react-native-paper"
import { uniqBy } from "lodash"
import { Entypo, AntDesign, Fontisto } from "@expo/vector-icons"
import { POST_TYPE, WORKSHOP_TYPE } from "@Utils/utils"

const ConclusionWorkshops = ({ workshops, title, isPost }) => {
    const data = workshops ?? []
    const filteredData = uniqBy(data, "id") ?? []

    const icon = (postType) => {
        switch (postType) {
            case POST_TYPE.videos:
                return <Entypo name="video" size={24} color={baseColors.green.primary} />

            case POST_TYPE.image:
                return <Entypo name="images" size={24} color={baseColors.green.primary} />

            case WORKSHOP_TYPE.visio:
                return <AntDesign name="videocamera" size={24} color={baseColors.green.primary} />

            case WORKSHOP_TYPE.inSite:
                return <Fontisto name="persons" size={24} color={baseColors.green.primary} />

            default:
                return <Entypo name="text" size={24} color={baseColors.green.primary} />
        }
    }

    return (
        <View
            style={[
                styles.container,
                { backgroundColor: baseColors.green.light, paddingHorizontal: 30, paddingTop: 20 }
            ]}
        >
            <Text
                style={{
                    marginBottom: 10,
                    fontSize: 14,
                    fontFamily: baseFontFamily.OpenSansSemiBold,
                    color: baseColors.green.primary
                }}
            >
                {title}
            </Text>

            {filteredData?.map((item) => (
                <View key={item?.id} style={{ flexDirection: "row", alignItems: "center", marginBottom: 15 }}>
                    <View
                        style={{ height: 7, width: 7, borderRadius: 10, backgroundColor: baseColors.orange.primary }}
                    />

                    <Text
                        numberOfLines={2}
                        style={{
                            flex: 1,
                            left: 10,
                            fontSize: 12,
                            fontFamily: baseFontFamily.OpenSansSemiBold,
                            color: baseColors.black
                        }}
                    >
                        {item?.workshop?.name ?? item?.article?.title ?? ""}
                    </Text>

                    {icon(isPost ? item?.article?.postType?.code : item?.workshop?.type?.code)}
                </View>
            ))}

            <Spacer height={20} />
        </View>
    )
}

export default ConclusionWorkshops
